import axios from "axios";

import { env } from "@monta/env";

import type { NextPageContext } from "next";
import type { AxiosError } from "axios";
import type { IAxiosInstance, TAxiosConfig } from "./types";
import type { Auth } from "./auth";

const methods = [
  "request",
  "delete",
  "get",
  "head",
  "options",
  "post",
  "put",
  "patch"
] as const;

function createApi(options: {
  ctx?: NextPageContext;
  auth?: Auth;
  baseURL?: string;
}) {
  const { auth, baseURL, ctx } = options;

  const api = axios.create({
    baseURL: baseURL || env.API_URL
  }) as IAxiosInstance;

  const axiosExtra: any = {};

  for (const method of methods) {
    axiosExtra["$" + method] = function (...args: unknown[]) {
      return this[method](...args).then(
        (res: { data?: unknown; isAxiosError }) => {
          if (res.isAxiosError) {
            return Promise.reject(res);
          }
          return res?.data;
        }
      );
    };
  }

  for (const key in axiosExtra) {
    api[key as keyof IAxiosInstance] = axiosExtra[key].bind(api);
  }

  // @ts-expect-error
  api.interceptors.request.use(async (config: TAxiosConfig<any>) => {
    if (auth?.token) {
      // if (!config.noRefreshToken) {
      //   // if (!auth.refreshing && auth.isExpired()) await auth.refresh();
      //   if (auth.refreshing) {
      //     ServerLogger.log(
      //       String(config.url) + ": waiting for refreshtoken to finish",
      //       "AXIOS",
      //       "magentaBright"
      //     );
      //     await auth.refreshing;
      //   }
      // }

      config.headers = {
        ...(config.headers || {}),
        Authorization: auth.token
      };
    }

    if ((ctx?.req as any)?.cookies)
      config.headers = {
        ...(config.headers || {}),
        cookie: ctx?.req ? (ctx?.req as any).cookies : {}
      };

    return config;
  });

  api.interceptors.response.use(
    (config) => config,
    (error: AxiosError) => {
      if (
        !(error.config as TAxiosConfig<unknown>)?.doNotLogout &&
        error.response?.status === 401
      )
        auth?.logout();
      return Promise.reject(error);
    }
  );

  return api;
}

export default createApi;
